export default "__VITE_ASSET__BeiV3Nk9__"